import * as React from "react";
import { forwardRef } from "react";
const SvgFileIcon = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" width={11} height={14} viewBox="0 0 11 14" ref={ref} {...props}><path fill="#32325D" d="M6.875 0h-5.5C.619 0 .007.63.007 1.4L0 12.6c0 .77.612 1.4 1.368 1.4h8.257c.756 0 1.375-.63 1.375-1.4V4.2L6.875 0zm-5.5 12.6V1.4h4.813v3.5h3.437v7.7h-8.25z" /></svg>;
const ForwardRef = forwardRef(SvgFileIcon);
export { ForwardRef as ReactComponent };
import __svgUrl from "/home/jenkins/agent/workspace/k_Connect_service_dev_qa-release/src/images/createloan/file_icon.svg?url";
export default __svgUrl;
